function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import DndList from "./dnd-list";
import Checkbox from "../checkbox-tag";
var FormList = function FormList(props) {
  var onChange = props.onChange,
    index = props.index,
    items = props.items,
    onValid = props.onValid,
    value = props.value,
    create = props.create;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    elements = _useState2[0],
    setElements = _useState2[1];
  var isDynamicChange = onChange && typeof onChange === 'function';

  /**
   * @param {object} list
   * @param {object} currentElement
   *
   * @returns {object}
   */
  var addElementToList = function addElementToList(list, currentElement) {
    list = list || {};
    var index = Object.keys(list).length + 1;
    list[index] = currentElement;
    return list;
  };
  /**
   * @param {object} response
   */
  var handleOnClick = function handleOnClick(response) {
    // if not object assign, it will not reload this component.
    var listElement = elements ? Object.assign({}, elements) : {};

    // if dynamic change
    if (isDynamicChange) {
      var newValue = !value ? {} : value;
      listElement = newValue[index] || {};
      var _newElement = addElementToList(listElement, response);
      onChange(_newElement, index);
      return;
    }
    var newElement = addElementToList(listElement, response);
    setElements(newElement);
  };
  var handleValid = function handleValid() {
    if (onValid && typeof onValid === 'function') {
      onValid(elements);
    }
  };
  var handleUpdateListElement = function handleUpdateListElement(elements) {
    if (isDynamicChange) {
      onChange(elements, index);
      return;
    }
    setElements(elements);
  };
  var handleDelete = function handleDelete(key) {
    if (elements[key]) {
      delete elements[key];
    }
    var newElements = {};
    var i = 1;
    Object.keys(elements).forEach(function (key) {
      newElements[i] = elements[key];
      i++;
    });
    if (isDynamicChange) {
      onChange(newElements, index);
    }
    setElements(newElements);
  };
  useEffect(function () {
    if (!onChange) {
      return;
    }
    setElements(value[index] || {});
  }, [value, index, onChange]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
    elements: items,
    onChange: handleOnClick,
    isConnectedToCollector: false
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(DndList, {
    elements: elements,
    index: index,
    setElements: handleUpdateListElement,
    creationMode: true,
    onDeleteElement: handleDelete,
    create: create
  }), onValid && /*#__PURE__*/React.createElement(Button, {
    color: "danger",
    className: "collectorButtonForce",
    onClick: handleValid
  }, "Valider"));
};
FormList.propTypes = {
  onChange: PropTypes.func,
  onValid: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  create: PropTypes.bool
};
FormList.defaultProps = {
  elements: {},
  onChange: null,
  onValid: null,
  create: false
};
export default FormList;